import { format } from 'date-fns'
import config from '@/config'
import moment from 'moment'

let mappers = {}

function isTrue (input) {
  return isTrue ? '是' : '否'
}

export function hyToText (input, type) {
  const enumTypeText = mappers[type]
  if (!enumTypeText) {
    return ''
  }
  if (!input && input !== false) {
    input = 0
  }
  const result = enumTypeText.find(obj => {
    return obj.value === input
  })
  return result && result.text
}

function date (input, formatStr = 'yyyy-MM-dd HH:mm:ss') {
  if (input === 0 || !input) {
    return '无'
  }
  return format(new Date(input), formatStr)
}

export function getFilterList (arrayList, val) {
  if (!arrayList || arrayList.length === 0) {
    return
  }
  val = val || 0
  return arrayList.filter(data => data['buyStatus'] === val)
}

function qiniu (input = '', type = 'fw') {
  if (input === '') {
    return ''
  }

  if (input.indexOf('http') === 0) {
    return input
  }

  return type === 'fw' ? `${config.QINIU_URL}${input}` : `${config.LOTTERY_QINIU_URL}${input}`
}

function currency (input = '', locale = 'zh-CN', currency = 'CNY') {
  const currencyNumber = Number(input)

  if (isNaN(currencyNumber)) {
    return input
  }

  return currencyNumber
    .toLocaleString(locale, { style: 'currency', currency })
    .slice(0, -3) // 去除后3位(小数点)
}

const filters = {
  isTrue,
  hyToText,
  date,
  getFilterList,
  qiniu,
  currency,
  momentDate,
  logDate,
  formatTimeSpan
}

export function registerMappers (mapperModel) {
  mappers = mapperModel
}

export function registerFilters (Vue) {
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
  })
}

function momentDate (time, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(time).format(pattern)
}

function logDate (time) {
  const year = new Date(time).getFullYear()
  const month = new Date(time).getMonth() + 1
  const day = new Date(time).getDate()
  return year + '年' + month + '月' + day + '日更新'
}

function formatTimeSpan (timespan) {
  if (Number.isNaN(timespan)) {
    return timespan
  }
  const year = 3600000 * 24 * 30 * 12
  const month = 3600000 * 24 * 30
  const day = 3600000 * 24
  const hour = 3600000
  const minute = 60000
  let res = {}
  // 时间间隔大于一年

  res.year = Math.floor(timespan / year)
  res.month = Math.floor((timespan % year) / month)
  res.day = Math.floor(((timespan % year) % month) / day)
  res.hour = Math.floor((((timespan % year) % month) % day) / hour)
  res.minute = Math.floor(((((timespan % year) % month) % day) % hour) / minute)
  let str = ''
  if (res.year) {
    str = `${res.year}年${res.month}月${res.day}天${res.hour}时${res.minute}分`
  } else if (res.month) {
    str = `${res.month}月${res.day}天${res.hour}时${res.minute}分`
  } else if (res.day) {
    str = `${res.day}天${res.hour}时${res.minute}分`
  } else if (res.hour) {
    str = `${res.hour}时${res.minute}分`
  } else {
    str = `${res.minute}分`
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filter/index.js